import { render, staticRenderFns } from "./unvalidated_orders.vue?vue&type=template&id=9aaec760&scoped=true&"
import script from "./unvalidated_orders.vue?vue&type=script&lang=js&"
export * from "./unvalidated_orders.vue?vue&type=script&lang=js&"
import style0 from "./unvalidated_orders.vue?vue&type=style&index=0&id=9aaec760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaec760",
  null
  
)

export default component.exports